import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/configuracion/configuraciones-de-las-infracciones/';

/**
 * GET Configuraciones Infracciones
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getConfiguracionesInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Configuracion Infracciones
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConfiguracionInfracciones = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Configuracion Infracciones
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionInfracciones = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion Infracciones
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionInfracciones = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ConfiguracionInfracciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConfiguracionInfracciones = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
